export default "__VITE_PUBLIC_ASSET__0c1cd25d__"